var _circle, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 47,
    fill: "url(#paint0_linear_2011_24)",
    stroke: "url(#paint1_radial_2011_24)",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.9387 42.1112C71.7768 42.5542 71.6304 43.5145 71.1288 44.223C69.3061 46.7895 69.5091 49.1395 71.1093 51.8134C72.8579 54.7332 71.9739 56.968 68.9665 58.5684C68.1352 59.0115 67.3272 59.5072 66.4666 59.8839C65.5221 60.2977 65.0986 60.9847 64.9659 61.9723C64.8078 63.1629 64.6029 64.3495 64.3472 65.5245C63.8301 67.9115 61.781 69.309 59.3532 68.9811C58.0652 68.8074 56.7811 68.5575 55.4872 68.4951C54.9408 68.4678 54.2695 68.7039 53.8382 69.0513C52.9053 69.8028 52.1013 70.7142 51.2251 71.5379C49.1584 73.4818 46.7814 73.4877 44.7167 71.5535C43.8619 70.7533 43.0188 69.9413 42.1992 69.104C41.68 68.5732 41.1102 68.3428 40.3608 68.46C39.1099 68.659 37.8492 68.7996 36.5943 68.9791C34.1373 69.3304 32.0667 67.8998 31.5632 65.4542C31.3134 64.2461 31.1066 63.0262 30.929 61.8064C30.8002 60.9281 30.3943 60.327 29.5727 59.9405C28.5442 59.4565 27.5509 58.9022 26.5556 58.3518C24.1162 57.0051 23.3726 54.7566 24.5435 52.2408C25.0509 51.1517 25.5681 50.0646 26.1301 49.0048C26.5009 48.3041 26.4853 47.6717 26.1204 46.975C25.5466 45.882 25.008 44.7714 24.4987 43.6472C23.4156 41.2641 24.1376 39.0215 26.4053 37.7314C27.5333 37.0893 28.7335 36.5643 29.8264 35.8694C30.2655 35.5903 30.6733 35.0438 30.8041 34.5422C31.1398 33.258 31.2861 31.9249 31.5535 30.6212C32.0706 28.0975 34.0885 26.6825 36.6216 27.0299C37.8765 27.2017 39.1294 27.4534 40.3901 27.5022C40.9658 27.5237 41.6644 27.2778 42.1191 26.9148C43.0559 26.1692 43.8541 25.2519 44.7342 24.4302C46.7716 22.5292 49.1369 22.5233 51.1704 24.4126C52.0037 25.1875 52.8292 25.974 53.6157 26.7957C54.2051 27.4125 54.8452 27.6779 55.7077 27.5276C56.9236 27.3168 58.1511 27.1782 59.3747 27.0143C61.7907 26.6884 63.8379 28.1034 64.3492 30.4982C64.6126 31.7356 64.8234 32.9886 65.0049 34.2417C65.1278 35.0926 65.5377 35.6528 66.3124 36.0353C67.4775 36.6092 68.6289 37.2142 69.7491 37.8719C71.1718 38.7093 71.9641 40.1399 71.9387 42.1112ZM59.1171 38.4458C58.7385 37.993 58.477 37.4835 58.0613 37.2279C57.3822 36.8082 56.7713 37.1596 56.2444 37.6846C50.0463 43.8912 43.8404 50.09 37.6443 56.2985C36.8793 57.0656 36.8324 57.897 37.4628 58.5216C38.0912 59.1422 38.9128 59.0856 39.6856 58.3127C45.8915 52.1139 52.0954 45.9132 58.2857 39.6988C58.5863 39.3924 58.7717 38.9708 59.1171 38.4458ZM42.1933 35.0536C39.2894 35.0575 36.9144 37.4328 36.9241 40.3234C36.9319 43.2003 39.348 45.6107 42.2109 45.6029C45.0855 45.5951 47.48 43.1846 47.4781 40.3058C47.4722 37.4035 45.105 35.0497 42.1933 35.0536ZM53.7191 60.9457C56.625 60.9515 59.002 58.5938 59.0098 55.6954C59.0176 52.8224 56.6152 50.4062 53.7425 50.3964C50.8738 50.3866 48.4695 52.7873 48.4597 55.672C48.45 58.5782 50.8055 60.9398 53.7191 60.9457Z",
    fill: "url(#paint2_radial_2011_24)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6132 40.3273C44.6035 41.633 43.4716 42.7396 42.1679 42.7182C40.8585 42.6967 39.7578 41.5549 39.7968 40.255C39.8339 38.9845 40.9229 37.9168 42.1914 37.9071C43.4891 37.8993 44.621 39.0293 44.6132 40.3273Z",
    fill: "url(#paint3_radial_2011_24)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7777 58.0883C52.4838 58.1195 51.3324 57.0051 51.3187 55.7071C51.3051 54.4444 52.3569 53.3416 53.6333 53.285C54.9408 53.2265 56.0863 54.2921 56.1351 55.6115C56.1839 56.9094 55.0911 58.0571 53.7777 58.0883Z",
    fill: "url(#paint4_radial_2011_24)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2011_24",
    x1: 48,
    y1: 0,
    x2: 48,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8178FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2011_24",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.9909 31.9457) scale(66.7143 66.7141)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1515,
    stopColor: "#F7CD70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9694,
    stopColor: "#F24303"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2011_24",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.9954 39.6384) scale(33.3572 34.7469)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1515,
    stopColor: "#F7CD70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9694,
    stopColor: "#F24303"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2011_24",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.9954 39.6384) scale(33.3572 34.7469)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1515,
    stopColor: "#F7CD70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9694,
    stopColor: "#F24303"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2011_24",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.9954 39.6384) scale(33.3572 34.7469)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1515,
    stopColor: "#F7CD70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9694,
    stopColor: "#F24303"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.ddfd14e67e6e197483b13b2a6dfaa655.svg";
export { ForwardRef as ReactComponent };